import * as React from "react"
import type { SVGProps } from "react"
const SvgInformationCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 17.86q.42 0 .71-.29a1 1 0 0 0 .29-.71v-4a1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28 1 1 0 0 0-.71.28 1 1 0 0 0-.29.72v4q0 .42.29.71.29.3.71.29m0-8q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28 1 1 0 0 0-.71.28 1 1 0 0 0-.29.72q0 .42.29.71.29.3.71.29m0 13a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.08.79-3.9a10 10 0 0 1 2.13-3.18Q6.28 4.43 8.1 3.65a10 10 0 0 1 3.9-.8q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.79m0-2q3.35 0 5.68-2.33A7.7 7.7 0 0 0 20 12.86q0-3.36-2.33-5.68A7.7 7.7 0 0 0 12 4.86q-3.34 0-5.67 2.32A7.7 7.7 0 0 0 4 12.86q0 3.34 2.33 5.67A7.7 7.7 0 0 0 12 20.86" />
  </svg>
)
export default SvgInformationCircle
